import { render, staticRenderFns } from "./MainSponsors.vue?vue&type=template&id=6d78c040&"
import script from "./MainSponsors.vue?vue&type=script&lang=js&"
export * from "./MainSponsors.vue?vue&type=script&lang=js&"
import style0 from "./MainSponsors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports